<template>
  <div class="column is-12">
            <!----------- text ---------------------------------->
            <div class="field">
              <div class="control">
                <label class="label">{{ elLabel }}</label>
                <vue-editor 
                v-model="n" 
                :editorToolbar="customToolbar"
                ></vue-editor>
              </div>
            </div>
          </div>
</template>

<script>
import { VueEditor } from 'vue2-editor'
export default {
  // inject: ['$validator'],
  props: ['data', 'elLabel'],
  data () {
    return {
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [ { 'script': 'sub' }, { 'script': 'super' } ],
        [ { 'list': 'ordered' }, { 'list': 'bullet' } ],
        ['blockquote'],
        [{ 'header': [2, 3, 4, 5, 6, false] }],
        ['link'],
        ['clean']
      ]
    }
  },
  computed: {
    n: {
      get () {
        return this.data
      },
      set (value) {
        this.$emit('wasUpdated', value)
      }
    }
  },
  components: {
    VueEditor
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/cms/elements/HTML.vue